import React from 'react';
import { Helmet } from "react-helmet";
import './style.css';
import Footer from 'components/Footer/Footer';
import home from 'Assets/home.svg';
import { Button, Container, Row, Col, Form, Image, ProgressBar } from "react-bootstrap";
// , Spinner, Tabs, Tab, Card, CardDeck, Table
import { org_friendly_url, apiUrl, user_Status, user_Status_Ver, myHeaders_Auth_With_Cache_Control } from 'Api/Api';
import { UploadAsset } from 'Api/UploadAsset';
import axios from 'axios';
//import bus_brands from 'Assets/bus_brands.png';

import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';

import bsCustomFileInput from 'bs-custom-file-input';

import { local_routes } from 'utils/Routes';
//import { stripe_plans } from 'utils/stripe_plans';

//import { pricing_matrix } from 'utils/pricing_matrix';

import SignupModal from 'components/Modals/SignupModal';
import VerificationModal from 'components/Modals/VerificationModal';

import UserContext from 'store/UserContext';

import ReactTooltip from 'react-tooltip';

// import { Link } from 'react-router-dom';

import QuickCreatePresentation from 'pages/PKCreation/PKCreationSteps/Audio/PresentationSingleRecording/QuickCreatePresentation';

//import ipk2021_img from "Assets/internationalpk/ipk2021_skinny_banner.png";
import ipk_img from "Assets/internationalpk/ipk2022_pkmaker.png";

import { massageFriendlyUrl, get_current_unix_stamp } from "utils/Helper";

import sanitize from 'sanitize-filename';

import Countdown from 'react-countdown';

//import HubspotForm from 'react-hubspot-form'

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
//const stripePromise = loadStripe(process.env.REACT_APP_PK_STRIPE_KEY);

//const hubspot_portalId = '6817434';
//const hubspot_formId = '689dadb1-8a7b-44c1-b9f8-bea31e54b6fa';

const category_uuid_obj = {
  //staging: '0b5d38be-dfd2-45fa-9510-c00877792fbb',
  //live: 'de02ea8f-1c38-4faf-9ddf-4106d5d76c05',
  staging: '25ddb25c-fcb9-4fed-9405-43589ad0372c',
  live: '00b53404-1a01-4183-aa3e-47f87ff519ea'
}

const event_uuid_obj = {
  staging: 'c46f1311-9854-4101-93fc-89d9fd0a42f6',
  live: 'b91cc9e8-0da1-4729-baf5-a78073a71232'
}



class QuickCreate extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    
    this.state = {
      loading: true,
      saving: false,
      show_signup_modal: false,
      verification_modal_show: false,
      presentation_name: '',
      slide_image: null,
      slide_image_name: '',
      audioOutput: null, // returned from QuickCreatePresentation
      language_abbreviation: 'en-US', // returned from QuickCreatePresentation
      message: '',
      audio_message: '',
      validated: false,
      waiting_for_video_presentation_uuid: ''
    };

    this.workspace_base_url = '';
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
    
    //this.presentation_name_form_control_ref = React.createRef();
    this.form_ref = React.createRef();
    
    this.auto_refresh_time = 5;
    
    this.countdownMillis = 25000;
    
    //this.form_anchor_ref = React.createRef();
  }
  
  componentWillUnmount() {
    clearInterval(this.check_for_live_presentation_interval);
  }

  componentDidMount = async function () {
    bsCustomFileInput.init();
    
    this.setState({
      loading: false
    });
  }
  
  checkForLivePresentation = async function () {
    if (!this.state.waiting_for_video_presentation_uuid) {
      return;
    }
    
    let params = {
      attributes: ['status_code','friendly_url']
    }
    
    let presentation_result = await axios.get(`${apiUrl}presentations/${this.state.waiting_for_video_presentation_uuid}`, { params, ...myHeaders_Auth_With_Cache_Control });
    
    if (presentation_result.data.status_code === 1 && presentation_result.data.friendly_url) {
      console.log("Video Ready!");
      clearInterval(this.check_for_live_presentation_interval);
      this.props.history.push(`${this.workspace_base_url}${local_routes.presentations}/${presentation_result.data.friendly_url}`);
    }
  }
  
  onChangeFile = (event) => {
    console.log("onChangeFile",event.target.files);
    //if (!this.checkUserEligible()) {
    //  return;
    //}
    if (event.target.files[0]) {
      this.setState({
        slide_image: event.target.files[0],
        slide_image_name: event.target.files[0].name,
        message: ''
      });
    }
  }
  
  checkUserEligible = (event) => {
    console.log("checkUserEligible",event);
    if (!this.context.user_info.entity_uuid) {
      console.error("NO user!");
      if (event && event.stopPropagation) {
        console.error("Stop propogation!");
        event.preventDefault();
        event.stopPropagation();
        if (event.target && event.target.blur) {
          event.target.blur();
        }
      }
      window.localStorage.setItem('loginOrigin',this.props.location.pathname);
      this.setState({
        show_signup_modal: true
      });
      return false;
    }
    if (this.context.user_info.status_code !== 1) {
      console.error("NO user is not verified!");
        this.setState({
          verification_modal_show: true
        });
      return false;
    }
    
    return true;
  }
  
  handleFinishClick = async () => {
    console.log("handleFinishClick");
    
    if (!this.checkUserEligible()) {
      return false;
    }
    
    /*
    if (!this.context.user_info.entity_uuid) {
      console.error("NO user!");
      window.localStorage.setItem('loginOrigin',this.props.location.pathname);
      this.setState({
        show_signup_modal: true
      });
      return;
    }
    if (this.context.user_info.status_code !== 1) {
      console.error("NO user is not verified!");
        this.setState({
          verification_modal_show: true
        });
      return;
    }
    */
    
    // validate required data
    // 1) presentation name
    if (!this.form_ref.current.checkValidity()) {
      this.setState({
        //message: <span style={{ color: 'red' }}>FORM INVALID BOO</span>,
        validated: true
      });
      return;
    }
    
    /*
    if (!this.presentation_name_form_control_ref.current.checkValidity()) {
      console.log("FORM CONTROL",this.presentation_name_form_ref.current.validity,this.presentation_name_form_ref.current.validationMessage,this.presentation_name_form_ref.current.willValidate);
      this.setState({
        message: <span style={{ color: 'red' }}>FORM INVALID Presentation Name must be 3 or more characters long</span>,
        validated: true
      });
      return;      
    }
    */
    
    if (this.state.presentation_name.length < 3) {
      // should never get here
      this.setState({
        message: <span style={{ color: 'red' }}>Presentation Name must be 3 or more characters long</span>
      });
      return;
    }

    if (!this.state.slide_image) {
      // should never get here
      this.setState({
        message: <span style={{ color: 'red' }}>Please upload an image</span>
      });
      return;
    }

    if (!this.state.audioOutput) {
      this.setState({
        audio_message: <span style={{ color: 'red' }}>Please record your audio</span>
      });
      return;
    }

    this.setState({
      saving: true,
      //message: <span style={{ color: 'green' }}>Working...</span>
    });
    
    //console.log("What now?");
    
    // now save the work!
    // 1) create new presentation
    this.setState({
      audio_message: '',
      message: <span style={{ color: 'green' }}>Creating Presentation</span>
    })

    let tmp_friendly_url = massageFriendlyUrl(this.state.presentation_name);
    tmp_friendly_url = sanitize(this.state.presentation_name);
        
    let post_obj = {
      entity_name: this.state.presentation_name,
      description: this.state.presentation_name,
      friendly_url: tmp_friendly_url,
      slide_count: 1,
      slide_length: 20,
      allow_comments: 'all',
      categories: [{ entity_uuid: category_uuid_obj[process.env.REACT_APP_PK_ENV] }],
      events: [{
        entity_uuid: event_uuid_obj[process.env.REACT_APP_PK_ENV],
        xref_data: {
          submitted_time: get_current_unix_stamp()
        }
      }],
      auto_publish: true,
      public_status: 'public',
      status_code: 4,
      users: [{
        entity_uuid: this.context.user_info.entity_uuid,
        xref_data: {
          entity_owner_integer: 1,
          presenter_integer: 1
        }
      }],
      current_slide_count: 1
    };
    let create_presentation_result = await axios.post(`${apiUrl}presentations`, post_obj );
    
    let presentation_uuid = create_presentation_result.data.entity_uuid;
    
    // 2.1) create slide
    this.setState({
      message: <span style={{ color: 'green' }}>Uploading Image</span>
    })
    post_obj = {
      entity_name: this.state.presentation_name+' slide 1',
      friendly_url: tmp_friendly_url+'-slide_1-'+get_current_unix_stamp(),
      presentations: [{
        entity_uuid: presentation_uuid,
        xref_data: {
          order_integer: 1
        }
      }]
    }
    let create_slide_result = await axios.post(`${apiUrl}slides`, post_obj );
    
    // 2.2) upload slide
    let upload_asset_config = {
      asset_data: this.state.slide_image,
      entity_type: 'slides',
      entity_uuid: create_slide_result.data.entity_uuid,
      asset_type: 'image',
      onProgressDisplayUpdate: (message) => this.setState({message})
    };
    //let slide_image_url = await this.uploadAsset(upload_asset_config);
    let slide_image_url = await UploadAsset(upload_asset_config);
    
    // 3) upload audio
    this.setState({
      message: <span style={{ color: 'green' }}>Uploading Audio</span>
    })
    upload_asset_config = {
      asset_data: this.state.audioOutput,
      entity_type: 'presentations',
      entity_uuid: presentation_uuid,
      asset_type: 'raw_audio',
      onProgressDisplayUpdate: (message) => this.setState({message})
    }
    //let audio_url = await this.uploadAsset(upload_asset_config);
    let audio_url = await UploadAsset(upload_asset_config);
    
    // 4) trigger create video
    this.setState({
      message: <span style={{ color: 'green' }}>Triggering Video Creation</span>
    })
    let patch_obj = {
      trigger_create_presentation_video: true,
      trigger_create_presentation_pptx: true, // this usually happes in upload slides step
      trigger_create_presentation_slides_zip: true, // this usually happes in upload slides step
      //trigger_create_presentation_transcript: true, // this is done automatically in process_video_in_video
      language_abbreviation: 'en-US',
      audio_delay: 0,
      video_assembly_method: 'presentation_audio',
      wrapup_time_ms: 0,
      image_url: slide_image_url // cover image
    }
    let update_presentation_result = await axios.patch(`${apiUrl}presentations/${presentation_uuid}`, patch_obj );
    
    this.setState({
      saving: false,
      message: <span style={{ color: 'green' }}>Done!</span>,
      waiting_for_video_presentation_uuid: presentation_uuid
    });
    
    this.check_for_live_presentation_interval = setInterval(() => this.checkForLivePresentation(), this.auto_refresh_time * 1000);
  }
  
  uploadAsset = async (config) => {
    console.log("uploadAsset", config);
    let asset_data_promise = new Promise(resolve => {
      let reader = new FileReader();
      reader.readAsArrayBuffer(config.asset_data);
      reader.onload = () => resolve(reader.result);
    });
    let asset_file_name;
    if (config.asset_data.name) {
      // image file - could be .jpg, .png, .gif, etc.
      asset_file_name = config.entity_type+'_'+config.asset_type+'_'+(new Date().getTime())+'.'+config.asset_data.name.split('.').pop();
    } else {
      // recorded audio - will be webm or wav or mp4
      let extension = 'webm';
      if (config.asset_data && config.asset_data.type) {
        if (config.asset_data.type.startsWith('audio/wav')) {
          extension = "wav";
        } else if (config.asset_data.type.startsWith('audio/mp4')) {
          extension = "mp4";
        }
      }
      asset_file_name = config.entity_type+'_'+config.asset_type+'_'+(new Date().getTime())+'.'+extension;
    }
    let params = {
      asset_type: config.asset_type, // image or audio
      filename: asset_file_name
    };
    let gsu_response = await axios.post(`${apiUrl}${config.entity_type}/${config.entity_uuid}/getUploadSignedUrl`,{}, { params });
    
    let raw_asset_data = await asset_data_promise;
    let asset_length_bytes = raw_asset_data.byteLength;
    let pretty_asset_type = '';
    if (config.asset_type === 'raw_audio') {
      pretty_asset_type = 'Audio';
    } else {
      pretty_asset_type = 'Image';
    }
    const signed_url_upload_config = {
      headers: { "Content-Type": gsu_response.data.content_type },
      onUploadProgress: (progressEvent) => {
        let upload_percent = Math.floor(progressEvent.loaded / asset_length_bytes * 100);
        //console.log("SLIDE UPLOADING PROGRESS ("+i+")",progressEvent.loaded,upload_percent);
        this.setState({
          message: <span style={{ color: 'green' }}>{'Uploading '+pretty_asset_type+' '+upload_percent+'%'}</span>
        });
      }
    };
    let upload_url = gsu_response.data.upload_url;
    
    await axios.put(upload_url, raw_asset_data, signed_url_upload_config);
    
    return gsu_response.data.asset_url;
  }
  
  quickCreateCallback = async ( callback_obj ) => {
    console.log("quickCreateCallback", callback_obj);
    this.setState({
      ...callback_obj,
      audio_message: ''
    });
  }
  
  changeNameHandler = (event) => {
    if (!this.checkUserEligible()) {
      return;
    }
    this.setState({
      presentation_name: event.target.value
    });
  }
  
  goToMyPresentations = () => {
    this.props.history.push(`${this.workspace_base_url}${local_routes.pklist}`);
  }
  
  countdownRenderer = ({ hours, minutes, seconds, completed, total }) => {
    if (completed) {
      //console.log("countdownRenderer completed");
      // Render a completed state
      //return <span>Happy Creating!</span>;
      return (
        <ProgressBar variant="success" style={{ height: '24px' }} now={100} label="Ready! Go to 'My Presentations' to find your new video" />
      );
    } else {
      // Render a countdown
      
      let percent = (25000 - total) * 0.005;
      if (percent > 100) {
        percent = 100;
      } else if (percent < 0) {
        percent = 0;
      }
      this.countdownMillis = total;
      //console.log("countdownRenderer total percent",total,percent);
      return (
        <ProgressBar variant="success" animated={true} style={{ height: '24px' }} now={percent} />
      );
      /*
      return (
        <React.Fragment>
          <Spinner animation="grow" variant="success" />
          <span style={{ fontSize: '200%', margin: '20px' }}>
            {seconds}
          </span>
          <Spinner animation="grow" variant="success" />
        </React.Fragment>
      );
      */
    }
  }
  
  render() {
    if (this.state.waiting_for_video_presentation_uuid) {
      return (
        <React.Fragment>
          <Helmet defer={false}>
            <title>PechaKucha - What You Love</title>
            <meta name="description" content="PK Create is presentation software that makes it easy to make Pecha Kucha presentations. Sign up for your free Pecha Kucha account." />
          </Helmet>
          <Container>
            <Row style={{ marginTop: "20px", marginBottom: "10px" }} className="justify-content-center">
              <Col xs={"auto"}>
                <h2 style={{ color: "#EE220C" }}>TELL US WHAT YOU LOVE</h2>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col xs="auto" style={{ fontSize: "larger" }}>
                Congratulations! Your PechaKucha video presentation is currently being created.<br/>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col xs="auto" style={{ fontSize: "larger" }}>
                You will be redirected to your live video page when it is ready - typically less than 20 seconds!<br/>
              </Col>
            </Row>
            {/*
            <Row className="justify-content-center">
              <Col xs="auto">
                <Countdown
                  date={Date.now() + 20000}
                  renderer={this.countdownRenderer}
                />
              </Col>
            </Row>      
            */}
            <Row className="justify-content-center">
              <Col xs={1}>
              </Col>
              <Col xs={10} style={{ marginBottom: "20px" }}>
                <Countdown
                  date={Date.now() + this.countdownMillis}
                  renderer={this.countdownRenderer}
                  intervalDelay={200}
                  precision={1}
                />
              </Col>
              <Col xs={1}>
              </Col>
            </Row>        
            <Row className="justify-content-center">
              <Col xs="auto"
                //onClick={() => this.goToMyPresentations()}
                onClick={() => this.props.history.push(`${this.workspace_base_url}${local_routes.pklist}`)}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-angle-double-right"></i> For more creative power, go to your My Presentations page
              </Col>
            </Row>        
            <Row className="justify-content-center">
              <Col xs="auto"
                onClick={() => this.setState({waiting_for_video_presentation_uuid: '', presentation_name: '', slide_image: null, slide_image_name: '', audioOutput: null})}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-angle-double-right"></i> Create another short video presentation about something you love!
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col xs="auto"
                onClick={() => this.props.history.push(`/internationalpk`)}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-angle-double-right"></i> Learn more about International PechaKucha Day, and register for our 24-hour livestream on February 20th!
              </Col>
            </Row>
          </Container>
          <Footer
            homeImg={home}
            homeImgRef="/"
            breadcrumbSubPage="PK Maker"
          />
        </React.Fragment>
      );
    }

    if (this.state.loading || (user_Status && !this.context.user_info.entity_uuid)) {
      return (
          <FullPageSpinner />
      );
    }
    
    return (
      <React.Fragment>
        <Helmet>
          <title>PechaKucha - What You Love</title>
          <meta name="description" content="PK Create is presentation software that makes it easy to make Pecha Kucha presentations. Sign up for your free Pecha Kucha account." />
        </Helmet>
        <Container>
          <Row className="justify-content-center">
            <Col xs="auto">
              {this.state.message}
            </Col>
          </Row>
          <Row style={{ marginTop: "20px", marginBottom: "10px" }} className="justify-content-center">
            <Col xs={"auto"}>
              <h2 style={{ color: "#EE220C" }}>TELL US WHAT YOU LOVE</h2>
              <p>Create a video in 3 easy steps</p>
              {!this.context.user_info.entity_uuid &&
                <p style={{ cursor: "pointer" }} onClick={this.checkUserEligible}>(PK account required: login or signup for free)</p>
              }
              {(this.context.user_info.entity_uuid && this.context.user_info.status_code !== 1) &&
                <p style={{ cursor: "pointer" }} onClick={this.checkUserEligible}>(Account verification required)</p>
              }
            </Col>
          </Row>
          <Row style={{ marginBottom: "20px" }} className="pricing-plan-types">
            <Col xs={4} style={{ paddingBottom: "50px", paddingLeft: "30px", paddingRight: "30px" }}>
              <Image src={ipk_img} fluid />
            </Col>
            <Col xs={8}>
              <Form
                ref={this.form_ref}
                validated={this.state.validated}
                noValidate
              >
              <Row>
                <Col>
                  1. I Love...
                </Col>
              </Row>
              <Row className="justify-content-md-center" style={{ marginTop: "5px" }}>
                <Col xs={8}>
                  <Form.Group>
                    {/*<Form.Label>Presentation Name</Form.Label>*/}
                    <Form.Control
                      //ref={this.presentation_name_form_ref}
                      placeholder="Enter Presentation Name"
                      value={this.state.presentation_name || ''}
                      onChange={this.changeNameHandler}
                      onFocus={(event) => this.checkUserEligible(event)}
                      pattern=".{3,}"
                      maxLength={120}
                      disabled={this.state.saving}
                      //disabled={this.state.saving || (!this.context.user_info.entity_uuid || this.context.user_info.status_code !== 1)}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a title between 3 and 120 characters long
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  2. Upload Image
                </Col>
              </Row>
              <Row className="justify-content-md-center" style={{ marginTop: "5px" }}>
                <Col xs={8}>
                  <Form.Group>
                    <Form.Label>Image (16:9 aspect ratio recommended)</Form.Label>
                    <Form.File 
                      id="custom-file"
                      custom={true}
                      //disabled={this.state.saving || (!this.context.user_info.entity_uuid || this.context.user_info.status_code !== 1)}
                      //required
                    >
                      <Form.File.Label>{this.state.slide_image_name || 'Click to Upload Image File'}</Form.File.Label>
                      <Form.File.Input
                        accept='.jpg,.jpeg,.png,.gif'
                        disabled={this.state.saving}
                        onFocus={(event) => this.checkUserEligible(event)}
                        onChange={this.onChangeFile}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please select an image
                      </Form.Control.Feedback>
                    </Form.File>
                  </Form.Group>
                </Col>
              </Row>
              </Form>
              <Row>
                <Col>
                  3. Record Audio (talk for 20 seconds about what you love)
                </Col>
              </Row>
              <Row className="justify-content-md-center" style={{ marginTop: "5px" }}>
                {! this.state.saving ?
                  <Col xs={8}>
                    <React.Fragment>
                      <QuickCreatePresentation
                          checkUserEligible={this.checkUserEligible}
                          quickCreateCallback={this.quickCreateCallback}
                          audioType={'record'}
                          audio_delay={0}
                          language_abbreviation={'en-US'} // ??
                          slide_count={1}
                          slide_length={20}
                          wrapup_time_ms={0}
                          silent_flag={false}
                      />
                      <center>{this.state.audio_message}</center>
                    </React.Fragment>
                  </Col>
                  :
                  <Col xs={8}>
                    <span style={{ color: 'green', fontSize: 'larger' }}>Saving...</span>
                  </Col>
                }
              </Row>
              <Row>
                <Col>
                  4. Create your Presentation Video
                </Col>
              </Row>
              <Row className="justify-content-md-center">
                <Col xs={2} md={4} lg={5}>
                  &nbsp;
                </Col>
                <Col xs={10} md={8} lg={7}>
                  <Button
                    variant="danger"
                    onClick={this.handleFinishClick}
                    disabled={this.state.saving}
                  >
                    FINISH
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        
        { !user_Status &&
          <SignupModal
            show={this.state.show_signup_modal}
            onHide={() => this.setState({show_signup_modal:false})}
            reload={true}
          >
          </SignupModal>
        }
        
        { user_Status_Ver !== "1" &&
          <VerificationModal
              show={this.state.verification_modal_show}
              onHide={() => this.setState({ verification_modal_show: false})}
          />
        
        }
        
        <div className="pk-create-footer">
          <Footer
            homeImg={home}
            homeImgRef="/"
            breadcrumbSubPage="PK Maker"
          />
        </div>
        <ReactTooltip/>
      </React.Fragment>
    );
  }
}

export default QuickCreate;
